module.exports = __webpack_public_path__ + "static/media/bg8.439977ae.png";